import { h } from 'preact';
import * as BaseComp from 'components/bolt/landingAudio/landingAudio.js';
// import s from 'components/bolt/landingAudio/landingAudio.sss';
import Store from 'store/store';

export default class LandingAudio extends BaseComp.default {

	togglePlaying(muted) {
		const { userMuted } = this.state;
		if (typeof muted !== 'boolean') {
			muted = !userMuted;
		}
		this.setState({ userMuted: muted });
		Store.emit('SET_MUTED', muted);
	}
}
